module.exports = __webpack_public_path__ + "static/media/md-git-commit.7c36d11c.svg";